import React from 'react';
import PropTypes from 'prop-types';
import Carousel from 'components/Carousel';
import moment from 'moment-timezone';
import { Empty } from 'antd';

const validationErrorRenderer = item => (
  <div>
    <div>
      <strong>Error message: </strong>
      {item.error_msg}
    </div>
    <div>
      <strong>User: </strong>
      {item.affected_assignment.user.last_name}
      ,
      {item.affected_assignment.user.first_name}
    </div>
    <div>
      <strong>Assignment: </strong>
      {item.affected_assignment.activity.name}
    </div>
    <div>
      <strong>Assignment start: </strong>
      {moment(item.affected_assignment.start)
        .format('YYYY-MM-DD HH:mm')}
    </div>
    <div>
      <strong>Assignment end: </strong>
      {moment(item.affected_assignment.end)
        .format('YYYY-MM-DD HH:mm')}
    </div>
  </div>
);

const FormInput = ({ dataSource }) => {
  const { id, validation_errors } = dataSource;
  let emptyMessage = null;
  if (id < 0) {
    emptyMessage = 'Select a task to view its validation errors';
  }
  else if (validation_errors && validation_errors.length === 0) {
    emptyMessage = 'No validation errors detected for the selected task';
  }
  if (emptyMessage) {
    return (
      <div className="bhp-container">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={emptyMessage}
        />
      </div>
    );
  }
  if (Array.isArray(validation_errors)) {
    let i = 1;
    const errors = validation_errors.map(v => ({
      key: v.id,
      order: i++,
      ...v
    }));

    return (
      <div style={{ margin: '0 20px' }}>
        <Carousel
          columns={2}
          title={item => `Validation Error ${item.order}`}
          columnWidth={8}
          items={errors}
          style={{ margin: '20px' }}
          itemRenderer={validationErrorRenderer}
        />
      </div>
    );
  }
  return (<span />);
};

FormInput.propTypes = {
  dataSource: PropTypes.object
};

FormInput.defaultProps = {
  dataSource: {}
};

export default FormInput;
